import React, { useState, useEffect, useContext } from "react";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";
import {
  format as formatDate,
  getYear,
  getMonth,
  getDaysInMonth,
} from "date-fns";
import enUS from "date-fns/locale/en-US";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
const locales = {
  "en-US": enUS,
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

const EmployeeAttendance = () => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [events, setEvents] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(getMonth(new Date()) + 1);
  const [currentYear, setCurrentYear] = useState(getYear(new Date()));
  const [holidays, setHolidays] = useState([]);
  const { password, username } = billpunchbasicauth;

  const getEmployeeAttendance = async (year, month) => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          month: month.toString(),
          year: year.toString(),
          token: user.login_token,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetEmployeeAttendanceDetails`,
        requestOptions
      );
      const data = await res.json();

      const totalDays = getDaysInMonth(new Date(year, month - 1));
      const allDates = Array.from(
        { length: totalDays },
        (_, i) => new Date(year, month - 1, i + 1)
      );

      if (data.status === "0" && data.data) {
        const apiDates = data.data.map((item) =>
          new Date(item.attendance_date).toDateString()
        );

        const mappedEvents = data.data.map((item) => {
          const inTime = item.in_time || "-";
          const outTime = item.out_time || "-";
        
          let title = "";
        
          if (item.type === "SL") {
            title = `Sick Leave (SL)\n${inTime} - ${outTime}`;
          } else if (item.type === "PL") {
            title = `Paid Leave (PL)\n${inTime} - ${outTime}`;
          } else if (item.type === "HalfDay") {
            title = `Half Day\n${inTime} - ${outTime}`;
          } else if (item.type === "LATE") {
            title = `Late\n${inTime} - ${outTime}`;
          } else if (item.type === "WFH") {
            title = `Work From Home\n${inTime} - ${outTime}`;
          } else if (item.attendance_status === "Y") {
            // ✅ Fixed: show Present with times on next line
            title = `Present\n${inTime} - ${outTime}`;
          } else {
            // ✅ Fixed: show Absent with times below (usually will be "- -")
            title = `Absent\n${inTime} - ${outTime}`;
          }
        
          return {
            title,
            start: new Date(item.attendance_date),
            end: new Date(item.attendance_date),
            allDay: true,
            status: item.attendance_status,
            type: item.type,
          };
        });
        
        

        const absentDates = allDates
          .filter((date) => !apiDates.includes(date.toDateString()))
          .map((date) => ({
            title: "Absent",
            start: date,
            end: date,
            allDay: true,
            status: "N",
          }));

        setEvents([...mappedEvents, ...absentDates]);
      }

      setTransactionLoaderState(false);
    } catch (error) {
      console.error("error", error);
      setTransactionLoaderState(false);
    }
  };

  const getHolidays = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firmid: user.firm_id,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetFirmHoliday`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0" && data.data) {
        const mappedHolidays = data.data.map((holiday) => {
          const [day, month, year] = holiday.datee.split("/");
          const startDate = new Date(
            parseInt(year),
            parseInt(month) - 1,
            parseInt(day)
          );
          return {
            title: holiday.holiday,
            start: startDate,
            end: startDate,
            allDay: true,
            holiday: true,
          };
        });

        setHolidays(mappedHolidays);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("error", error);
      setTransactionLoaderState(false);
    }
  };

  useEffect(() => {
    getEmployeeAttendance(currentYear, currentMonth);
    getHolidays();
  }, [currentYear, currentMonth]);

  const handleNavigate = (date) => {
    setCurrentMonth(getMonth(date) + 1);
    setCurrentYear(getYear(date));
  };

  const eventStyleGetter = (event, start, end, isSelected) => {
    let backgroundColor = "#3174ad";

    if (event.holiday) {
      backgroundColor = "green";
    } else if (event.status === "N") {
      backgroundColor = "red";
    } else if (event.type === "HalfDay") {
      backgroundColor = "orange";
    } else if (event.type === "SL") {
      backgroundColor = "#5D8736";
    } else if (event.type === "PL") {
      backgroundColor = "#5D8736";
    } else if (event.type === "LATE") {
      backgroundColor = "#2D4F2B";
    }
    let style = {
      backgroundColor,
      borderRadius: "5px",
      opacity: 0.9,
      color: "#fff",
      border: "0",
      display: "block",
      whiteSpace: "pre-line", 
      fontSize: "0.75rem",
      padding: "4px",
    };
    
    return {
      style: style,
    };
  };

  return (
    <div className="mt-4 p-2">
      <Calendar
        localizer={localizer}
        events={[...events, ...holidays]}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 600 }}
        onNavigate={handleNavigate}
        defaultView="month"
        eventPropGetter={eventStyleGetter}
      />
    </div>
  );
};

export default EmployeeAttendance;
